"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
//# sourceMappingURL=department.list.js.map